// src/auth/registerApi.js
const register = async (formData) => {
  try {
    const response = await fetch('https://campus.acetians.in/api/v3/signup', {
      method: 'POST',
      body: formData,
   
    });

    const data = await response.json();
    
    
    return data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

export default register;